import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faUserPlus } from '@fortawesome/pro-solid-svg-icons';

const AddContactOption = ({ company, data, innerProps, innerRef, label }) => (
  <div ref={innerRef} {...innerProps} className="entity" onClick={data.onClick}>
    <FontAwesomeIcon className="type-icon" icon={company ? faPlus : faUserPlus} pull="left" size="lg" />

    <div>
      <div>
        <strong>{label}</strong>
      </div>
    </div>
  </div>
);

AddContactOption.propTypes = {
  company: PropTypes.bool,
  data: PropTypes.shape({
    onClick: PropTypes.func.isRequired
  }).isRequired,
  innerProps: PropTypes.object,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  label: PropTypes.string.isRequired
};

export default AddContactOption;
